module.exports = __webpack_public_path__ + "img/huxiaoying.cc83deb0.jpg";